// BP-ASYNC-GEN-02: backend now returns 202 { job_id } within ~2s. The poll
// flow lives in GeneratingPage — no AbortController needed on this call.
export async function generateStory({ learnerId, topic }) {
  const { api } = await import('./client');
  return api.post('/stories/generate', { child_profile_id: learnerId, theme: topic });
}

export async function getGenerationStatus(jobId) {
  const { api } = await import('./client');
  return api.get(`/stories/generation-status/${jobId}`);
}

export async function getStory(storyId) {
  const { api } = await import('./client');
  return api.get(`/stories/${storyId}`);
}

export async function getChildStories(learnerId) {
  const { api } = await import('./client');
  return api.get(`/stories/child/${learnerId}`);
}

export async function markStoryRead(storyId) {
  const { api } = await import('./client');
  return api.patch(`/stories/${storyId}/read`);
}

export async function submitStoryReview(storyId, { hardCharacterIds = [] } = {}) {
  const { api } = await import('./client');
  return api.patch(`/stories/${storyId}/review`, { hardCharacterIds });
}
